import { SelectOption } from '@fleet-beat/core';
import { EditorFieldType } from '../../enums/editor-field-type-enum.service';
import { EditorFieldConfigBase } from './editor-field-config-base.model';

export interface CheckboxListFieldConfig extends EditorFieldConfigBase {
  type: EditorFieldType.CHECKBOX_LIST;

  options?: SelectOption[];
}
